/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-undef */
import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_HOST}/api` || 'http://localhost:3011/';
export const api = axios.create({baseURL, maxRedirects: 1, timeout: 60000});

api.interceptors.response.use(
  (response) => {
    if (api?.interceptors?.request?.handlers) {
      try {
        api.interceptors.request.handlers = [];
      } catch (e) {
        console.log('Error ejecting handler');
        console.log(e);
      }
    }
    return response;
  },
  (error) => {
    if (api?.interceptors?.request?.handlers) {
      try {
        api.interceptors.request.handlers = [];
      } catch (e) {
        console.log('Error ejecting handler');
        console.log(e);
      }
    }

    return Promise.reject(error);
  }
);

async function getTemporaryToken({ip, locale, userAgent}) {
  try {
    const response = await api.post(`user/auth/telegram-bot`, {
      ip,
      user_agent: userAgent,
      geo: locale,
    });

    if (response.data.success) {
      return response.data;
    } else {
      console.error('Основной сервер не отвечае', response?.data?.error);
      return null;
    }
  } catch (error) {
    return console.error('Error token:', error);
  }
}

async function checkTemporaryToken(token) {
  try {
    const response = await api.get(`user/auth/telegram-bot/${encodeURIComponent(token)}`);
    return response.data;
  } catch (error) {
    const errorData = error?.response?.data;
    console.error('Error checking temporary token:', errorData || error);
    return errorData || null;
  }
}

async function telegramAuth({idToken, telegramUser, nonce, ip, locale, userAgent}) {
  try {
    const response = await api.post(`user/auth/telegram`, {
      id_token: idToken,
      user: telegramUser,
      nonce,
      ip,
      user_agent: userAgent,
      geo: locale,
    });

    if (!!response?.data?.success) {
      return response.data;
    } else {
      console.error('Telegram auth error:', response?.data?.message || response?.data?.error);
      return response?.data || null;
    }
  } catch (error) {
    const errorData = error?.response?.data;
    console.error('Telegram auth error:', errorData?.message || errorData?.error || error);

    if (errorData && typeof errorData === 'object') {
      return {
        ...errorData,
        success: false,
        http_status: error?.response?.status,
      };
    }

    return {
      success: false,
      code: error?.response?.status === 404 ? 'not_found' : undefined,
      http_status: error?.response?.status,
      message:
        typeof errorData === 'string' && errorData ? errorData : 'Telegram authorization failed.',
    };
  }
}

async function verifyAuth({main_token, user_ip, user_locale, user_agent}) {
  try {
    const response = await api.post(
      `authVerify?ip=${user_ip}&user_agent=${user_agent}&geo=${user_locale}&main_token=${main_token}`
    );
    if (!!response?.data?.success) {
      return response.data.data;
    } else {
      console.error('Токен не прошел проверку:', response?.data?.message);
      return {
        authFailed: true,
        http_status: response?.status,
        message: response?.data?.message,
      };
    }
  } catch (error) {
    console.error('Error token:', error);
    const status = error?.response?.status;

    if ([401, 403].includes(status)) {
      return {
        authFailed: true,
        http_status: status,
        message: error?.response?.data?.message || error?.response?.data?.error,
      };
    }

    if (status === 503) {
      return {
        serviceUnavailable: true,
        http_status: status,
      };
    }

    return {
      networkError: true,
      http_status: status,
      message: error?.message,
    };
  }
}

async function revokeToken(token, revoke_token) {
  try {
    const response = await api.post(`revokeToken`, {token, revoke_token});
    if (!!response?.data?.success) {
      return true;
    } else {
      console.error('Произошла ошибка:', response?.data?.message);
      return false;
    }
  } catch (error) {
    console.error('Error token:', error);
    return null;
  }
}

async function revokeTempToken(token) {
  try {
    const response = await api.delete(`user/auth/telegram-bot/${encodeURIComponent(token)}`);
    if (!!response?.data?.success) {
      return console.log('Веременный токен удален!');
    } else {
      console.error('Произошла ошибка:', response?.data?.message);
      return null;
    }
  } catch (error) {
    console.error('Error token:', error);
    return null;
  }
}

async function getIp() {
  try {
    const response = await api.get(`public/client`);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}

export default {
  client: api,
  getTemporaryToken,
  checkTemporaryToken,
  telegramAuth,
  verifyAuth,
  revokeToken,
  revokeTempToken,
  getIp,
};
